import { Button, Dropdown, LazyLoader, NotificationActiveIcon, NotificationDefaultIcon } from '@bp/ui-components';
import classNames from 'classnames';
import { useMessageCommands } from 'matrix/commands/useMessageCommands';
import { Suspense } from 'react';
import { RoomType } from '../../../../matrix/constants';
import { useHasUnread } from '../../../../matrix/hooks/useNotifications';
import styles from '../_Flyouts.module.scss';
import { NotificationsFlyoutContent } from './NotificationsFlyoutContent';

type NotificationsFlyoutProps = { navigate: (to: string) => void };

const NotificationsFlyout = ({ navigate }: NotificationsFlyoutProps) => {
  const { markAllAsRead } = useMessageCommands();

  const hasUnread = useHasUnread({ excludeRoomTypes: [RoomType.DM] });

  return (
    <Dropdown
      noPadding
      className={styles.flyout}
      trigger={
        <Button
          hierarchy='tertiary'
          icon={
            hasUnread ? (
              <NotificationActiveIcon className={classNames('svg-icon', styles['notifications-active'])} />
            ) : (
              <NotificationDefaultIcon />
            )
          }
        />
      }
    >
      <Suspense fallback={<LazyLoader embedded transparent />}>
        <NotificationsFlyoutContent
          navigate={navigate}
          onMarkAllAsRead={async () => {
            await markAllAsRead({ excludeRoomTypes: [RoomType.DM] });
          }}
        />
      </Suspense>
    </Dropdown>
  );
};

export { NotificationsFlyout };
